import { Card, CardContent } from '@bpinternal/ui-kit-next'
import { AlertTriangle, ExternalLink } from 'lucide-react'
import { getCdmStudioUrl } from '~/shared/configurations'

type Props = {
  botId: string
}

export const PublishRequiredCard = ({ botId }: Props) => {
  return (
    <div className="flex w-full justify-center">
      <Card className="flex max-w-lg flex-col gap-2 self-center p-4 shadow-lg">
        <h2 className="text-lg font-semibold">Action required</h2>
        <Card className="border-amber-200 bg-amber-50">
          <CardContent className="p-4">
            <div className="flex items-start gap-3">
              <AlertTriangle className="mt-0.5 h-5 w-5 flex-shrink-0 text-amber-700" />
              <div className="space-y-2">
                <p className="text-sm text-amber-700">
                  To view Conversation history and Insights, you must publish this bot from the Studio.
                </p>
              </div>
            </div>
          </CardContent>
        </Card>
        <a
          href={getCdmStudioUrl(botId)}
          className="flex items-center gap-1 self-end text-sm text-brand-700 underline hover:text-brand-600"
          target="_blank"
          rel="noopener noreferrer"
        >
          Open Studio
          <ExternalLink className="h-3 w-3" />
        </a>
      </Card>
    </div>
  )
}
